
export default {
  head() {
    return {
      title:
        "Agence Google Ads | SEA à Villeurbanne dès 290€/mois - ALEO AGENCY",
      meta: [
        {
          hid: "description",
          name: "description",
          content:
            "ALEO, agence Google Ads à Villeurbanne certifiée Google Partner, aide les entreprises à accroître leur visibilité et à attirer plus de prospects dans la région lyonnaise.",
        },
        {
          hid: "og:title",
          property: "og:title",
          content:
            "Agence Google Ads à Villeurbanne dès 290€/mois - ALEO AGENCY",
        },
        {
          hid: "og:description",
          property: "og:description",
          content:
            "ALEO, agence Google Ads à Villeurbanne certifiée Google Partner, aide les entreprises à accroître leur visibilité et à attirer plus de prospects dans la région lyonnaise.",
        },
      ],
    };
  },
};
